<template>
	<article class="d-kultu-naut-overview-page-custom bg-primary-light">
		<PageHero v-bind="{ ...header, breadcrumb }" />
		<PostScribeScript
			v-if="script && !demoMode"
			class="bg-primary pb-xl px-layout-margin"
			:html="script"
		/>
		<div v-if="demoMode" class="bg-primary pb-xl px-layout-margin">
			<div class="flex items-center w-full <768:hidden">
				<select
					id="drop-down"
					name="drop-down"
					:class="[
						'text-h5 h-56 py-xs px-sm text-text mt-xs mr-md',
						'w-3col bg-white rounded-full',
					]"
				>
					<option value="one">Fra: Startdato</option>
					<option value="two">Two</option>
					<option value="three">Three</option>
				</select>
				<select
					id="drop-down-2"
					name="drop-down-2"
					:class="[
						'text-h5 h-56 py-xs px-sm text-text mt-xs mr-md',
						'w-3col bg-white rounded-full',
					]"
				>
					<option value="one">Til: Slutdato</option>
					<option value="two">Two</option>
					<option value="three">Three</option>
				</select>
				<div class="flex items-center w-3col h-full">
					<input
						id="radio"
						value="value"
						type="radio"
						name="Kun endagsarrangementer"
						:class="[
							'overflow-hidden',
							'relative appearance-none cursor-pointer',
							'w-16 h-16 rounded-full border-2 border-primary-button',
						]"
					/>

					<label
						:class="[
							'ml-8 cursor-pointer whitespace-no-wrap',
							' text-text',
						]"
						v-text="'Kun endagsarrangementer'"
					></label>
				</div>
				<a
					class="
						flex
						items-center
						text-primary-button
						w-3col
						h-full
						gap-8
						hover:text-primary-button-hover
					"
					target="_blank"
					href="https://www.kultunaut.dk/perl/quickadd/type-nynaut"
					><span
						class="
							text-button
							uppercase
							text-primary-button
							font-semibold
						"
						>Opret arrangement</span
					><SvgPlusIcon class="w-16"
				/></a>
			</div>
			<div class="flex w-full">
				<div class="relative w-6col mr-md mt-xs">
					<input
						type="text"
						name="Name"
						placeholder="Jeg leder efter..."
						:class="[
							'text-h5 h-56 py-xs px-sm text-text flex-grow',
							'w-6col bg-white rounded-full',
						]"
					/>
					<button
						:class="[
							'absolute top-1/2 right-8',
							'transform -translate-y-1/2',
							'rounded-full bg-extra w-40 h-40',
							'flex justify-center items-center',
						]"
						aria-label="Søg"
					>
						<SvgSearch class="w-16 h-16 text-white" />
					</button>
				</div>
				<select
					id="drop-down-3"
					name="drop-down-3"
					:class="[
						'<768:hidden text-h5 h-56 py-xs px-sm text-text mt-xs mr-md',
						'w-6col bg-white rounded-full',
					]"
				>
					<option value="one">Se alle kategorier</option>
					<option value="two">Two</option>
					<option value="three">Three</option>
				</select>
			</div>
			<div
				class="
					>=768:hidden
					flex flex-col
					text-h4
					font-semibold
					min-h-56
					h-fit
					py-xs
					px-sm
					text-primary-button
					mt-xs
					w-full
					bg-primary-medium
				"
				:class="filterOpen ? 'rounded-lg' : 'rounded-full'"
			>
				<div
					class="
						flex
						justify-center
						items-center
						cursor-pointer
						uppercase
					"
					@click="filterOpen = !filterOpen"
				>
					<span>{{ filterOpen ? 'LUK' : 'Filtrer' }}</span>
					<SvgClose v-if="filterOpen" class="ml-xs w-18 h-12" />
					<SvgToggleIcon v-else class="ml-xs w-18 h-12" />
				</div>
				<div v-if="filterOpen">
					<select
						id="drop-down-3"
						name="drop-down-3"
						:class="[
							'text-h5 h-56 py-xs px-sm text-text mt-xs',
							'w-full bg-white rounded-full',
						]"
					>
						<option value="one">Se alle kategorier</option>
						<option value="two">Two</option>
						<option value="three">Three</option>
					</select>
					<select
						id="drop-down"
						name="drop-down"
						:class="[
							'text-h5 h-56 py-xs px-sm text-text mt-xs',
							'w-full bg-white rounded-full',
						]"
					>
						<option value="one">Fra: Startdato</option>
						<option value="two">Two</option>
						<option value="three">Three</option>
					</select>
					<select
						id="drop-down-2"
						name="drop-down-2"
						:class="[
							'text-h5 h-56 py-xs px-sm text-text mt-xs',
							'w-full bg-white rounded-full',
						]"
					>
						<option value="one">Til: Slutdato</option>
						<option value="two">Two</option>
						<option value="three">Three</option>
					</select>
					<div
						class="
							flex
							items-center
							justify-center
							mt-sm
							w-full
							h-full
						"
					>
						<input
							id="radio"
							value="value"
							type="radio"
							name="Kun endagsarrangementer"
							:class="[
								'overflow-hidden',
								'relative appearance-none cursor-pointer',
								'w-16 h-16 rounded-full border-2 border-primary-button',
							]"
						/>

						<label
							:class="[
								'ml-8 cursor-pointer whitespace-no-wrap',
								'font-semibold text-text',
							]"
							v-text="'Kun endagsarrangementer'"
						></label>
					</div>
				</div>
			</div>
			<div
				class="
					>=768:hidden
					flex
					justify-center
					items-center
					w-full
					mt-md
				"
			>
				<a
					class="
						flex
						items-center
						text-primary-button
						hover:text-primary-button-hover
						h-full
						gap-8
					"
					target="_blank"
					href="https://www.kultunaut.dk/perl/quickadd/type-nynaut"
					><span
						class="
							text-button
							uppercase
							text-primary-button
							font-semibold
						"
						>Opret arrangement</span
					><SvgPlusIcon class="w-16"
				/></a>
			</div>

			<div class="text-h3 mt-lg mb-sm text-primary-button font-semibold">
				Viser 1-12 ud af 304 arrangementer
			</div>
			<div
				class="
					grid grid-cols-1
					>=768:grid-cols-3
					>=1024:grid-cols-4
					gap-x-layout-gutter gap-y-md
				"
			>
				<!-- Items -->
				<KultunautCard
					v-for="(item, index) in items"
					:key="`kultu-naut-${index}`"
					:name="item.name"
					:to="item.url"
					:target="item.target"
					:class="[
						'c-block-list-kultu-naut-custom__item',
						'>=768:w-3col w-full',
						'h-full',
					]"
					:image="{
						...(item.image || {}),
						aspectRatio: 1.5,
					}"
					light
				>
					<template #before>
						<div class="flex items-center text-12 w-full">
							<SvgCalendarIcon class="w-16 h-16 mr-8" />
							<span class="mr-24">{{ item.date }}</span>
							<SvgClockIcon class="w-14 h-14 mr-8" />
							<span>{{ item.time }}</span>
						</div>
					</template>
					<template #after>
						<div class="flex flex-col items-start w-full text-body">
							<span class="font-semibold">Sted</span>
							<span class="text-14">{{ item.location }}</span>
							<span class="font-semibold mt-xs">Pris</span>
							<span class="text-14">{{ item.price }}</span>
						</div>
					</template>
				</KultunautCard>
			</div>
		</div>
	</article>
</template>

<script>
import PageHero from '~/components/main/PageHero';
import SvgSearch from '~/assets/svgs/search-icon.svg?inline';
import SvgCalendarIcon from '~/assets/svgs/calendar-icon.svg?inline';
import SvgClockIcon from '~/assets/svgs/clock-icon.svg?inline';
import SvgToggleIcon from '~/assets/svgs/toggle-icon.svg?inline';
import SvgClose from '~/assets/svgs/close-icon.svg?inline';
import KultunautCard from '~/components/shared/KultunautCard';
import SvgPlusIcon from '~/assets/svgs/plus-icon.svg?inline';
import PostScribeScript from '~/citi-baseline/components/PostScribeScript';

export default {
	name: 'MainKultuNautOverviewPageCustom',
	components: {
		PageHero,
		SvgSearch,
		SvgCalendarIcon,
		SvgClockIcon,
		KultunautCard,
		SvgToggleIcon,
		SvgClose,
		SvgPlusIcon,
		PostScribeScript,
	},
	inheritAttrs: false,
	props: {
		title: String,
		script: String,
		header: {
			type: Object,
			required: true,
		},
		breadcrumb: {
			type: Array,
			required: false,
		},
	},
	data() {
		const { demo } = this.$route.query;
		const demoMode = demo !== undefined;
		return {
			filterOpen: false,
			demoMode,
			items: [
				{
					image: {
						width: 6720,
						height: 4480,
						cropUrl:
							'/media/0pfle5us/image-01.jpg?rnd=132974457460970000?width=6720&height=4480&rnd=2034116917',
						altText: 'Img01 Alt tag',
						id: 1161,
						url: '/media/0pfle5us/image-01.jpg',
						imageText: '<p>Beskrivende tekst til billedet.</p>',
						imageCredits: 'Fotograf: A',
						hasLocalCrops: false,
						fileType: 'Image',
					},
					date: '10.11.21 ',
					time: '10.00',
					name: 'Hyggeklubben',
					location: 'Vemmelev Sognelade Fruegade 19, Vemmelev',
					price: 'Gratis',
					url: '/da/kultunaut-arrangement/',
				},
				{
					image: {
						width: 6720,
						height: 4480,
						cropUrl:
							'/media/0pfle5us/image-01.jpg?rnd=132974457460970000?width=6720&height=4480&rnd=2034116917',
						altText: 'Img01 Alt tag',
						id: 1161,
						url: '/media/0pfle5us/image-01.jpg',
						imageText: '<p>Beskrivende tekst til billedet.</p>',
						imageCredits: 'Fotograf: A',
						hasLocalCrops: false,
						fileType: 'Image',
					},
					date: '10.11.21 ',
					time: '10.00',
					name: 'Hyggeklubben',
					location: 'Vemmelev Sognelade Fruegade 19, Vemmelev',
					price: 'Gratis',
					url: '/da/kultunaut-arrangement/',
				},
				{
					image: {
						width: 6720,
						height: 4480,
						cropUrl:
							'/media/0pfle5us/image-01.jpg?rnd=132974457460970000?width=6720&height=4480&rnd=2034116917',
						altText: 'Img01 Alt tag',
						id: 1161,
						url: '/media/0pfle5us/image-01.jpg',
						imageText: '<p>Beskrivende tekst til billedet.</p>',
						imageCredits: 'Fotograf: A',
						hasLocalCrops: false,
						fileType: 'Image',
					},
					date: '10.11.21 ',
					time: '10.00',
					name: 'Hyggeklubben',
					location: 'Vemmelev Sognelade Fruegade 19, Vemmelev',
					price: 'Gratis',
					url: '/da/kultunaut-arrangement/',
				},
				{
					image: {
						width: 6720,
						height: 4480,
						cropUrl:
							'/media/0pfle5us/image-01.jpg?rnd=132974457460970000?width=6720&height=4480&rnd=2034116917',
						altText: 'Img01 Alt tag',
						id: 1161,
						url: '/media/0pfle5us/image-01.jpg',
						imageText: '<p>Beskrivende tekst til billedet.</p>',
						imageCredits: 'Fotograf: A',
						hasLocalCrops: false,
						fileType: 'Image',
					},
					date: '10.11.21 ',
					time: '10.00',
					name: 'Hyggeklubben',
					location: 'Vemmelev Sognelade Fruegade 19, Vemmelev',
					price: 'Gratis',
					url: '/da/kultunaut-arrangement/',
				},
				{
					image: {
						width: 6720,
						height: 4480,
						cropUrl:
							'/media/0pfle5us/image-01.jpg?rnd=132974457460970000?width=6720&height=4480&rnd=2034116917',
						altText: 'Img01 Alt tag',
						id: 1161,
						url: '/media/0pfle5us/image-01.jpg',
						imageText: '<p>Beskrivende tekst til billedet.</p>',
						imageCredits: 'Fotograf: A',
						hasLocalCrops: false,
						fileType: 'Image',
					},
					date: '10.11.21 ',
					time: '10.00',
					name: 'Hyggeklubben',
					location: 'Vemmelev Sognelade Fruegade 19, Vemmelev',
					price: 'Gratis',
					url: '/da/kultunaut-arrangement/',
				},
				{
					image: {
						width: 6720,
						height: 4480,
						cropUrl:
							'/media/0pfle5us/image-01.jpg?rnd=132974457460970000?width=6720&height=4480&rnd=2034116917',
						altText: 'Img01 Alt tag',
						id: 1161,
						url: '/media/0pfle5us/image-01.jpg',
						imageText: '<p>Beskrivende tekst til billedet.</p>',
						imageCredits: 'Fotograf: A',
						hasLocalCrops: false,
						fileType: 'Image',
					},
					date: '10.11.21 ',
					time: '10.00',
					name: 'Hyggeklubben',
					location: 'Vemmelev Sognelade Fruegade 19, Vemmelev',
					price: 'Gratis',
					url: '/da/kultunaut-arrangement/',
				},
			],
		};
	},
};
</script>
